import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=aaff65f4"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"
import style0 from "./Select.vue?vue&type=style&index=0&id=aaff65f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports